<script lang="ts" setup>
import { convertStatus, getStatusStyle } from '@/utils/convertStatus'

const props = defineProps<{
  address: string
  projectName: string
  status?: string
  checked: boolean
}>()

const statusStyle = computed(() => getStatusStyle(props.status))
</script>

<template>
  <div
    class="flex cursor-pointer items-center gap-spacing-md rounded p-spacing-sm hover:bg-secondary-gray-200">
    <input
      name="account_site"
      type="radio"
      class="radio radio-sm border-accent-purple-400 checked:border-accent-purple-400 checked:bg-accent-purple-400"
      :checked="checked">
    <div class="mr-auto flex flex-col">
      <p class="secu-body-bold capitalize">
        {{ address }}
      </p>
      <p class="secu-body-small">
        {{ projectName }}
      </p>
    </div>
    <div
      :class="`secu-body-small secu-body-micro flex justify-between ${statusStyle?.statusColor}`">
      <div class="flex items-center gap-spacing-xs">
        <component :is="statusStyle?.statusIcon" class="size-6" /><span
          class="line-clamp-1">{{ $t(`${convertStatus(status ?? '')}`) }}</span>
      </div>
    </div>
  </div>
</template>
